import { createSlice } from '@reduxjs/toolkit';
import LoadingStatus from 'enums/loadingStatus';

/** Redux slice key used to mount this reducer in the shared store. */
export const DATA_SLICE_KEY = 'nativeInteractiveSiteMapData';

export function createNativeInteractiveSiteMapDataSlice({
  siteMapStatus = LoadingStatus.Idle.toString(),
  siteMapError = null,
} = {}) {
  return createSlice({
    name: DATA_SLICE_KEY,
    initialState: {
      siteMapStatus,
      siteMapError,
    },
    reducers: {
      fetchSiteMap: (state) => {
        state.siteMapStatus = LoadingStatus.Loading.toString();
        state.siteMapError = null;
      },
      fetchSiteMapSuccess: (state) => {
        state.siteMapStatus = LoadingStatus.Succeeded.toString();
      },
      fetchSiteMapError: (state, action) => {
        state.siteMapStatus = LoadingStatus.Failed.toString();
        state.siteMapError = action.payload;
      },
    },
  });
}